import { useContext } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import WelcomeBannerBanner from "../assets/welcomeBanner.png";
import classNames from "classnames";
import useStyles from "../styles/components/WelcomeBannerStyles";
import { useHistory } from "react-router-dom";
import DigitalPaymentBannerSVGR from "../smart-assets/SVGRs/DigitalPaymentBannerSVGR";
import useLanguage from "../hooks/useLanguage";
import { UserContext } from "../contexts/UserContext";

const WelcomeBanner = (props) => {
  const classes = useStyles(props);
  const history = useHistory();
  const {
    pages: {
      homePage: { welcomeBanner: STRINGS },
    },
  } = useLanguage();

  const { user } = useContext(UserContext);

  return (
    <Box className={classes.container}>
      <Box className={classes.imageCol}>
        <img
          src={WelcomeBannerBanner}
          alt="leadercard"
          className={classes.image}
        />
      </Box>

      <Box className={classes.infoContainer}>
        <Typography className={classes.title} variant="h4">
          {STRINGS.title}
        </Typography>

        <Box className={classes.paragraph}>
          <Box className={classes.svgAndText}>
            <DigitalPaymentBannerSVGR className={classes.svgAndTextSVG} />
            <Typography className={classes.svgAndTextText}>
              {STRINGS.benefitsList.digitalPayment}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.buttonsContainer}>
          <Button
            className={classNames(classes.button, classes.requestButton)}
            onClick={() => history.push(`/get-card`)}
          >
            {STRINGS.buttons.request}
          </Button>

          <Button
            className={classNames(classes.button, classes.moreInfoButton)}
            onClick={() => history.push(`/news`)}
          >
            {STRINGS.buttons.more}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default WelcomeBanner;
